// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__bviTo"};